import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";

@Injectable()
export class ReorderProposalEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.createProposalReorder.create),
			switchMap((action) => {
				return this.orderProposalService.createProposalReorder(action.proposalId).pipe(
					map((response) =>
						OrderProposalActions.createProposalReorder.createSuccess({
							proposalId: response.id
						})
					),
					catchError((error) =>
						of(OrderProposalActions.createProposalReorder.createFail({ error }))
					)
				);
			})
		)
	);

	submit = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.submitProposalReorder.submit),
			switchMap((action) => {
				return this.orderProposalService.submitProposalReorder(_.omit(action, "type")).pipe(
					map((response) =>
						OrderProposalActions.submitProposalReorder.submitSuccess({
							proposalId: response.id
						})
					),
					catchError((error) =>
						of(OrderProposalActions.submitProposalReorder.submitFail({ error }))
					)
				);
			})
		)
	);

	accept = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.acceptProposalReorder.accept),
			switchMap((action) => {
				return this.orderProposalService.acceptProposalReorder(action.proposalId).pipe(
					map((response) => OrderProposalActions.acceptProposalReorder.acceptSuccess()),
					catchError((error) =>
						of(OrderProposalActions.acceptProposalReorder.acceptFail({ error }))
					)
				);
			})
		)
	);

	deny = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.denyProposalReorder.deny),
			switchMap((action) => {
				return this.orderProposalService.denyProposalReorder(action.proposalId).pipe(
					map((response) => OrderProposalActions.denyProposalReorder.denySuccess()),
					catchError((error) =>
						of(OrderProposalActions.denyProposalReorder.denyFail({ error }))
					)
				);
			})
		)
	);

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService
	) {}
}
